import { bluePlanetTheme } from 'ui/theme';

interface RGBColor {
  red: number;
  green: number;
  blue: number;
}

function isValidHexColor(hex: string): boolean {
  const hexPattern = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return !!(hex && hexPattern.test(hex));
}

export function validateHexColor(hex: string, fallback: string = '#ffffff'): string {
  if (!isValidHexColor(hex)) {
    return fallback;
  }
  return hex.startsWith('#') ? hex : `#${hex}`;
}

export function convertHexToRGB(hex: string): RGBColor {
  if (!isValidHexColor(hex)) {
    // Return white if color is invalid
    return { red: 255, green: 255, blue: 255 };
  }

  const cleanHex = hex.replace('#', '');
  const split = cleanHex.match(/.{1,2}/g);
  const rgb = split?.map(s => parseInt(s, 16)) ?? [255, 255, 255];
  return { red: rgb[0], green: rgb[1], blue: rgb[2] };
}

export function contrastColorRGB(color: RGBColor) {
  return color.red * 0.299 + color.green * 0.587 + color.blue * 0.114 > 186
    ? bluePlanetTheme.bluePlanetPalette.indigo.main
    : bluePlanetTheme.palette.secondary.contrastText;
}
